<template>
  <div class="user-info-page">
    <v-card class="user-info-card" elevation="8">
      <v-card-title class="text-center signup-title">
        <div class="signup-title-text">사용자 정보 수정</div>
      </v-card-title>
      
      <v-card-text>
              <v-form ref="form" v-model="formValid" @submit.prevent="updateUserInfo">
                <!-- 기본 정보 섹션 -->
                <div class="form-section">
                  <h3 class="section-title">
                    <v-icon size="18" color="#133e87" class="mr-1">mdi-account-circle</v-icon>
                    기본 정보
                  </h3>
                  
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="compact-field">
                        <label class="compact-label">아이디</label>
                        <input
                          v-model="userInfo.m_id"
                          type="text"
                          class="compact-input"
                          readonly
                          :disabled="loading"
                          autocomplete="username"
                        />
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="compact-field">
                        <label class="compact-label">장기요양기관기호</label>
                        <input
                          v-model="userInfo.m_longterm_code"
                          type="text"
                          class="compact-input"
                          readonly
                          :disabled="loading"
                          autocomplete="off"
                        />
                      </div>
                    </v-col>
                  </v-row>
                  
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="compact-field required-field">
                        <label class="compact-label">대표자명 <span class="required-mark">*</span></label>
                        <input
                          v-model="userInfo.m_user_name"
                          type="text"
                          class="compact-input"
                          placeholder="대표자명을 입력하세요"
                          :disabled="loading"
                          autocomplete="name"
                          maxlength="20"
                        />
                        <span class="field-hint">임금신고 시 필수 입력 항목입니다.</span>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="compact-field required-field">
                        <label class="compact-label">기관명 <span class="required-mark">*</span></label>
                        <input
                          v-model="userInfo.m_sisul_name"
                          type="text"
                          class="compact-input"
                          placeholder="기관명을 입력하세요"
                          :disabled="loading"
                          autocomplete="organization"
                          maxlength="50"
                        />
                        <span class="field-hint">임금신고 시 필수 입력 항목입니다.</span>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- 업체 정보 섹션 -->
                <div class="form-section">
                  <h3 class="section-title">
                    <v-icon size="18" color="#133e87" class="mr-1">mdi-domain</v-icon>
                    업체 정보
                  </h3>
                  
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="compact-field">
                        <label class="compact-label">사업형태</label>
                        <input
                          v-model="userInfo.m_biz_gubun"
                          type="text"
                          class="compact-input"
                          placeholder="예: 재가장기요양센터"
                          :disabled="loading"
                          autocomplete="off"
                          maxlength="30"
                        />
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="compact-field required-field">
                        <label class="compact-label">사업자등록번호 <span class="required-mark">*</span></label>
                        <input
                          v-model="userInfo.m_biz_num"
                          type="text"
                          class="compact-input"
                          placeholder="123-45-67890"
                          :disabled="loading"
                          autocomplete="off"
                          @input="(e: any) => (userInfo.m_biz_num = formatBizNum(e.target.value))"
                          maxlength="12"
                        />
                        <span class="field-hint">임금신고 시 필수 입력 항목입니다.</span>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- 연락처 정보 섹션 -->
                <div class="form-section">
                  <h3 class="section-title">
                    <v-icon size="18" color="#133e87" class="mr-1">mdi-phone</v-icon>
                    연락처 정보
                  </h3>
                  
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="compact-field required-field">
                        <label class="compact-label">기관 전화번호 <span class="required-mark">*</span></label>
                        <div class="phone-input-group">
                          <input
                            v-model="userInfo.m_sisul_call_num1"
                            type="text"
                            class="compact-input phone-input"
                            placeholder="02"
                            :disabled="loading"
                            autocomplete="tel"
                            @input="(e: any) => (userInfo.m_sisul_call_num1 = numbersOnly(e.target.value).slice(0, 4))"
                            maxlength="4"
                          />
                          <span class="phone-separator">-</span>
                          <input
                            v-model="userInfo.m_sisul_call_num2"
                            type="text"
                            class="compact-input phone-input"
                            placeholder="1234"
                            :disabled="loading"
                            autocomplete="tel"
                            @input="(e: any) => (userInfo.m_sisul_call_num2 = numbersOnly(e.target.value).slice(0, 4))"
                            maxlength="4"
                          />
                          <span class="phone-separator">-</span>
                          <input
                            v-model="userInfo.m_sisul_call_num3"
                            type="text"
                            class="compact-input phone-input"
                            placeholder="5678"
                            :disabled="loading"
                            autocomplete="tel"
                            @input="(e: any) => (userInfo.m_sisul_call_num3 = numbersOnly(e.target.value).slice(0, 4))"
                            maxlength="4"
                          />
                        </div>
                        <span class="field-hint">임금신고 시 필수 입력 항목입니다.</span>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="compact-field">
                        <label class="compact-label">대표자 휴대폰</label>
                        <div class="phone-input-group">
                          <input
                            v-model="userInfo.m_phone1"
                            type="text"
                            class="compact-input phone-input"
                            placeholder="010"
                            :disabled="loading"
                            autocomplete="tel"
                            @input="(e: any) => (userInfo.m_phone1 = numbersOnly(e.target.value).slice(0, 3))"
                            maxlength="3"
                          />
                          <span class="phone-separator">-</span>
                          <input
                            v-model="userInfo.m_phone2"
                            type="text"
                            class="compact-input phone-input"
                            placeholder="1234"
                            :disabled="loading"
                            autocomplete="tel"
                            @input="(e: any) => (userInfo.m_phone2 = numbersOnly(e.target.value).slice(0, 4))"
                            maxlength="4"
                          />
                          <span class="phone-separator">-</span>
                          <input
                            v-model="userInfo.m_phone3"
                            type="text"
                            class="compact-input phone-input"
                            placeholder="5678"
                            :disabled="loading"
                            autocomplete="tel"
                            @input="(e: any) => (userInfo.m_phone3 = numbersOnly(e.target.value).slice(0, 4))"
                            maxlength="4"
                          />
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                  
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="compact-field">
                        <label class="compact-label">이메일</label>
                        <input
                          v-model="userInfo.m_email"
                          type="email"
                          class="compact-input"
                          placeholder="이메일을 입력하세요"
                          :disabled="loading"
                          autocomplete="email"
                          maxlength="100"
                        />
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="compact-field">
                        <label class="compact-label">팩스번호</label>
                        <div class="phone-input-group">
                          <input
                            v-model="userInfo.m_fax1"
                            type="text"
                            class="compact-input phone-input"
                            placeholder="02"
                            :disabled="loading"
                            autocomplete="tel"
                            @input="(e: any) => (userInfo.m_fax1 = numbersOnly(e.target.value).slice(0, 4))"
                            maxlength="4"
                          />
                          <span class="phone-separator">-</span>
                          <input
                            v-model="userInfo.m_fax2"
                            type="text"
                            class="compact-input phone-input"
                            placeholder="1234"
                            :disabled="loading"
                            autocomplete="tel"
                            @input="(e: any) => (userInfo.m_fax2 = numbersOnly(e.target.value).slice(0, 4))"
                            maxlength="4"
                          />
                          <span class="phone-separator">-</span>
                          <input
                            v-model="userInfo.m_fax3"
                            type="text"
                            class="compact-input phone-input"
                            placeholder="5678"
                            :disabled="loading"
                            autocomplete="tel"
                            @input="(e: any) => (userInfo.m_fax3 = numbersOnly(e.target.value).slice(0, 4))"
                            maxlength="4"
                          />
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- 은행 정보 섹션 -->
                <div class="form-section">
                  <h3 class="section-title">
                    <v-icon size="18" color="#133e87" class="mr-1">mdi-bank</v-icon>
                    은행 정보
                  </h3>
                  
                  <v-row>
                    <v-col cols="12" md="4" class="pb-0 pt-0">
                      <div class="compact-field">
                        <label class="compact-label">은행명</label>
                        <input
                          v-model="userInfo.m_bank_name"
                          type="text"
                          class="compact-input"
                          placeholder="은행명을 입력하세요"
                          :disabled="loading"
                          autocomplete="off"
                          maxlength="20"
                        />
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" class="pb-0 pt-0">
                      <div class="compact-field">
                        <label class="compact-label">계좌번호</label>
                        <input
                          v-model="userInfo.m_bank_num"
                          type="text"
                          class="compact-input"
                          placeholder="계좌번호를 입력하세요"
                          :disabled="loading"
                          autocomplete="off"
                          maxlength="50"
                        />
                      </div>
                    </v-col>
                    <v-col cols="12" md="4" class="pb-0 pt-0">
                      <div class="compact-field">
                        <label class="compact-label">예금주</label>
                        <input
                          v-model="userInfo.m_bank_owner"
                          type="text"
                          class="compact-input"
                          placeholder="예금주를 입력하세요"
                          :disabled="loading"
                          autocomplete="off"
                          maxlength="45"
                        />
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- 공인인증서 업로드 섹션 (디자인 전용) -->
                <!-- <div class="form-section">
                  <h3 class="section-title">공인인증서</h3>
                  <v-row>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="compact-field">
                        <label class="compact-label">공인인증서 파일</label>
                        <v-file-input
                          v-model="certFiles"
                          variant="outlined"
                          density="compact"
                          :disabled="loading"
                          clearable
                          accept=".pfx,.p12"
                          :show-size="true"
                          :multiple="false"
                          hint=".pfx 또는 .p12 파일만 업로드"
                          hint-class="text-red"
                          class="compact-file-input"
                        ></v-file-input>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6" class="pb-0 pt-0">
                      <div class="compact-field">
                        <label class="compact-label">공인인증서 비밀번호</label>
                        <div class="input-with-suffix">
                          <input
                            v-model="certPassword"
                            :type="showCertPassword ? 'text' : 'password'"
                            class="compact-input"
                            placeholder="공인인증서 비밀번호를 입력하세요"
                            :disabled="loading"
                            maxlength="50"
                            autocomplete="off"
                          />
                          <button
                            type="button"
                            class="password-toggle-btn"
                            @click="showCertPassword = !showCertPassword"
                          >
                            <v-icon size="16">{{ showCertPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                          </button>
                        </div>
                      </div>
                    </v-col>
                  </v-row>
                </div> -->

                <!-- 주소 정보 섹션 -->
                <div class="form-section">
                  <h3 class="section-title">
                    <v-icon size="18" color="#133e87" class="mr-1">mdi-map-marker</v-icon>
                    주소 정보
                  </h3>
                  
                  <div class="address-fields-wrapper">
                    <div class="compact-field required-field">
                      <label class="compact-label">주소 <span class="required-mark">*</span></label>
                      <div class="address-input-group">
                        <input
                          v-model="userInfo.m_addr"
                          type="text"
                          class="compact-input"
                          placeholder="주소 검색 버튼을 클릭하세요"
                          :disabled="loading"
                          readonly
                          autocomplete="street-address"
                          maxlength="150"
                          @click="openAddressModal"
                        />
                        <button
                          type="button"
                          class="address-search-btn"
                          @click="openAddressModal"
                        >
                          <v-icon size="14" class="mr-1">mdi-magnify</v-icon>
                          주소검색
                        </button>
                      </div>
                      <span class="field-hint">임금신고 시 필수 입력 항목입니다.</span>
                    </div>
                    <div class="compact-field">
                      <label class="compact-label">상세주소</label>
                      <input
                        v-model="userInfo.m_addr_detail"
                        type="text"
                        class="compact-input"
                        placeholder="상세주소를 입력해주세요 (동/호수 등)"
                        :disabled="loading"
                        autocomplete="address-line2"
                        maxlength="100"
                      />
                    </div>
                  </div>
                </div>

              </v-form>
            </v-card-text>
            
            <v-card-actions class="pl-4 pr-4 pt-2 pb-3">
              <v-row>
                <v-col cols="12" md="6">
                  <v-btn
                    @click="updateUserInfo"
                    color="primary"
                    variant="flat"
                    block
                    size="default"
                    :loading="loading"
                    rounded="lg"
                    class="signup-submit-btn"
                  >
                    <v-icon class="mr-2">mdi-content-save</v-icon>
                    정보 수정
                  </v-btn>
                </v-col>
                <v-col cols="12" md="6">
                  <v-btn
                    @click="openPasswordModal"
                    color="secondary"
                    variant="outlined"
                    block
                    size="default"
                    :disabled="loading"
                    rounded="lg"
                    class="login-back-btn"
                  >
                    <v-icon class="mr-2">mdi-lock-reset</v-icon>
                    비밀번호 변경
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-actions>
          </v-card>

    <!-- 비밀번호 변경 모달 -->
    <v-dialog class="password-dialog" v-model="passwordDialog" max-width="500" >
      <v-card rounded="lg">
        <v-card-title class="font-weight-bold d-flex align-center">
          <v-icon color="primary" class="mr-2">mdi-lock-reset</v-icon>
          비밀번호 변경
        </v-card-title>
        <v-card-text class="pa-4">
          <v-form ref="passwordForm" v-model="passwordFormValid">
            <div class="compact-field">
              <label class="compact-label">현재 비밀번호 *</label>
              <div class="input-with-suffix">
                <input
                  v-model="passwordData.currentPassword"
                  :type="showCurrentPassword ? 'text' : 'password'"
                  class="compact-input"
                  placeholder="현재 비밀번호를 입력하세요"
                  :disabled="passwordLoading"
                  autocomplete="current-password"
                  maxlength="50"
                />
                <button
                  type="button"
                  class="password-toggle-btn"
                  @click="showCurrentPassword = !showCurrentPassword"
                >
                  <v-icon size="16">{{ showCurrentPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                </button>
              </div>
            </div>
            
            <div class="compact-field">
              <label class="compact-label">새 비밀번호 *</label>
              <div class="input-with-suffix">
                <input
                  v-model="passwordData.newPassword"
                  :type="showNewPassword ? 'text' : 'password'"
                  class="compact-input"
                  placeholder="새 비밀번호를 입력하세요"
                  :disabled="passwordLoading"
                  @input="validateConfirmNewPassword"
                  autocomplete="new-password"
                  maxlength="50"
                />
                <button
                  type="button"
                  class="password-toggle-btn"
                  @click="showNewPassword = !showNewPassword"
                >
                  <v-icon size="16">{{ showNewPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                </button>
              </div>
            </div>
            
            <div class="compact-field">
              <label class="compact-label">새 비밀번호 확인 *</label>
              <div class="input-with-suffix">
                <input
                  v-model="passwordData.confirmNewPassword"
                  :type="showConfirmNewPassword ? 'text' : 'password'"
                  class="compact-input"
                  placeholder="새 비밀번호를 다시 입력하세요"
                  :disabled="passwordLoading"
                  autocomplete="new-password"
                  maxlength="50"
                />
                <button
                  type="button"
                  class="password-toggle-btn"
                  @click="showConfirmNewPassword = !showConfirmNewPassword"
                >
                  <v-icon size="16">{{ showConfirmNewPassword ? 'mdi-eye-off' : 'mdi-eye' }}</v-icon>
                </button>
              </div>
            </div>
          </v-form>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer></v-spacer>
          <v-btn
            variant="text"
            @click="closePasswordModal"
            :disabled="passwordLoading"
          >
            취소
          </v-btn>
          <v-btn
            color="primary"
            variant="flat"
            @click="changePassword"
            :loading="passwordLoading"
            :disabled="!passwordFormValid"
            rounded="lg"
          >
            <v-icon class="mr-2">mdi-check</v-icon>
            변경하기
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="addressDialog" max-width="560" >
      <v-card rounded="lg">
        <v-card-title class="text-subtitle-1 font-weight-bold">주소 검색</v-card-title>
        <v-card-text style="height: 420px; position: relative;">
          <div v-if="addressLoading" class="loading-overlay">
            <v-progress-circular
              indeterminate
              color="primary"
              size="48"
            ></v-progress-circular>
            <div class="loading-text mt-3">주소 검색을 불러오는 중...</div>
          </div>
          <div ref="postcodeContainer" style="width:100%; height:100%;" v-show="!addressLoading"></div>
        </v-card-text>
        <v-card-actions class="justify-end">
          <v-btn variant="text" @click="addressDialog = false" :disabled="addressLoading">닫기</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      v-model="snackbar.show"
      :color="snackbar.color"
      timeout="2500"
      rounded="lg"
      location="top"
    >
      {{ snackbar.message }}
    </v-snackbar>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, computed, nextTick, watch } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import axios from 'axios';

const store = useStore();
const router = useRouter();

// API 기본 URL
const API_BASE_URL = '/api';

// 이미지 경로 설정
const logoImage = ref(new URL('../../../assets/images/hypehive-logo.png', import.meta.url).href);

// 폼 유효성 검사
const formValid = ref(false);
const loading = ref(false);
const form = ref();
const snackbar = ref({ show: false, message: '', color: 'info' });
const addressDialog = ref(false);
const postcodeContainer = ref<HTMLDivElement | null>(null);
const addressLoading = ref(false);

// 비밀번호 변경 관련
const passwordDialog = ref(false);
const passwordFormValid = ref(false);
const passwordForm = ref();
const passwordLoading = ref(false);
const showCurrentPassword = ref(false);
const showNewPassword = ref(false);
const showConfirmNewPassword = ref(false);

const passwordData = ref({
  currentPassword: '',
  newPassword: '',
  confirmNewPassword: ''
});

// 공인인증서 업로드(디자인용)
// const certFiles = ref<File[]>([]);
// const certPassword = ref('');
// const showCertPassword = ref(false);

let daumScriptLoading: Promise<void> | null = null;

// 사용자 정보
const userInfo = ref({
  m_idx: 0,
  m_id: '',
  m_sisul_code: '',
  m_longterm_code: '',
  m_pw: '',
  m_sisul_name: '',
  m_biz_gubun: '',
  m_biz_num: '',
  m_user_name: '',
  m_email: '',
  m_sisul_call_num1: '',
  m_sisul_call_num2: '',
  m_sisul_call_num3: '',
  m_phone1: '',
  m_phone2: '',
  m_phone3: '',
  m_fax1: '',
  m_fax2: '',
  m_fax3: '',
  m_bank_num: '',
  m_bank_name: '',
  m_bank_owner: '',
  m_addr: '',
  m_addr_detail: ''
});

// 선택 옵션들
const bizGubunOptions = [
  { title: '재가장기요양센터', value: '재가장기요양센터' },
  { title: '주간보호센터', value: '주간보호센터' },
  { title: '단기보호센터', value: '단기보호센터' },
  { title: '기타', value: '기타' }
];


// 입력값 포맷터
const numbersOnly = (value: string) => value.replace(/[^\d]/g, '');

const formatPhone = (value: string) => {
  const digits = numbersOnly(value).slice(0, 11);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0,3)}-${digits.slice(3)}`;
  return `${digits.slice(0,3)}-${digits.slice(3,7)}-${digits.slice(7)}`;
};

const formatBizNum = (value: string) => {
  const digits = numbersOnly(value).slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 5) return `${digits.slice(0,3)}-${digits.slice(3)}`;
  return `${digits.slice(0,3)}-${digits.slice(3,5)}-${digits.slice(5)}`;
};

// 폼 유효성 검사 규칙
const rules = {
  required: (value: string) => !!value || '필수 입력 항목입니다.',
  email: (value: string) => {
    if (!value) return true; // 빈 값은 허용
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(value) || '올바른 이메일 형식이 아닙니다.';
  },
  phone: (value: string) => {
    if (!value) return true; // 빈 값은 허용
    const phoneRegex = /^01[0-9]-\d{4}-\d{4}$/;
    return phoneRegex.test(value) || '010-1234-5678 형식으로 입력해주세요.';
  },
  bizNum: (value: string) => {
    if (!value) return true; // 빈 값은 허용
    const bizNumRegex = /^\d{3}-\d{2}-\d{5}$/;
    return bizNumRegex.test(value) || '123-45-67890 형식으로 입력해주세요.';
  },
  password: (value: string) => value.length >= 6 || '6자 이상 입력해주세요.',
  confirmNewPassword: (value: string) => {
    if (!value) return '비밀번호 확인을 입력해주세요.';
    return value === passwordData.value.newPassword || '비밀번호가 일치하지 않습니다.';
  }
};

// 주소 검색 관련 함수들
const loadDaumPostcodeScript = async (): Promise<void> => {
  if ((window as any).daum?.Postcode) return;
  if (daumScriptLoading) {
    await daumScriptLoading;
    return;
  }
  daumScriptLoading = new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');
    script.src = 'https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js';
    script.onload = () => resolve();
    script.onerror = () => reject(new Error('Daum Postcode script load failed'));
    document.head.appendChild(script);
  });
  await daumScriptLoading;
};

const embedDaumPostcode = async () => {
  addressLoading.value = true;
  try {
    await loadDaumPostcodeScript();
    await nextTick();
    const container = postcodeContainer.value;
    if (!container) throw new Error('Container not ready');
    container.innerHTML = '';
    const Postcode = (window as any).daum?.Postcode;
    if (!Postcode) throw new Error('Daum Postcode is undefined');
    const postcode = new Postcode({
      oncomplete: (data: any) => {
        const road = data.roadAddress;
        const jibun = data.jibunAddress;
        const selected = road && road.length > 0 ? road : jibun;
        userInfo.value.m_addr = selected || '';
        addressDialog.value = false;
        addressLoading.value = false;
      },
      onresize: (size: any) => {
        try {
          (container as HTMLDivElement).style.height = `${size.height}px`;
        } catch {}
      },
      width: '100%',
      height: '100%'
    });
    try {
      postcode.embed(container, { autoClose: true });
      addressLoading.value = false;
    } catch (e) {
      addressLoading.value = false;
      throw e;
    }
  } catch (e) {
    addressLoading.value = false;
    throw e;
  }
};

const openDaumPostcodePopup = async () => {
  addressLoading.value = true;
  try {
    await loadDaumPostcodeScript();
    const Postcode = (window as any).daum?.Postcode;
    if (!Postcode) throw new Error('Daum Postcode not loaded');
    const postcode = new Postcode({
      oncomplete: (data: any) => {
        const road = data.roadAddress;
        const jibun = data.jibunAddress;
        const selected = road && road.length > 0 ? road : jibun;
        userInfo.value.m_addr = selected || '';
        addressLoading.value = false;
      }
    });
    postcode.open();
    addressLoading.value = false;
  } catch (e) {
    addressLoading.value = false;
    throw e;
  }
};

// 주소 찾기 모달 열기
const openAddressModal = async () => {
  addressDialog.value = true;
};

watch(addressDialog, async (val) => {
  if (val) {
    try {
      await embedDaumPostcode();
    } catch (e) {
      // 임베드 실패 시 팝업 방식으로 대체
      addressDialog.value = false;
      try {
        await openDaumPostcodePopup();
      } catch (err) {
        snackbar.value.message = '주소 검색 로드에 실패했습니다. 네트워크를 확인해주세요.';
        snackbar.value.color = 'error';
        snackbar.value.show = true;
      }
    }
  }
});

// 컴포넌트 마운트 시 로그인 상태 확인 및 사용자 정보 로드
onMounted(async () => {
  await store.dispatch('validateAuth');
  if (!store.getters.isLoggedIn) {
    router.push('/pgm/login');
    return;
  }
  
  // 현재 사용자 정보로 초기화
  const currentUser = store.getters.currentUser;
  if (currentUser) {
    userInfo.value = { ...currentUser };
  }
});

// 비밀번호 변경 모달 열기
const openPasswordModal = () => {
  passwordData.value = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  };
  passwordDialog.value = true;
};

// 비밀번호 변경 모달 닫기
const closePasswordModal = () => {
  passwordDialog.value = false;
  passwordData.value = {
    currentPassword: '',
    newPassword: '',
    confirmNewPassword: ''
  };
  showCurrentPassword.value = false;
  showNewPassword.value = false;
  showConfirmNewPassword.value = false;
};

// 새 비밀번호 확인 유효성 검사 강제 실행
const validateConfirmNewPassword = () => {
  if (passwordForm.value) {
    nextTick(() => {
      passwordForm.value.validate();
    });
  }
};

// 비밀번호 변경
const changePassword = async () => {
  if (!passwordFormValid.value) return;
  
  passwordLoading.value = true;
  try {
    const response = await axios.put(`${API_BASE_URL}/auth/password`, {
      currentPassword: passwordData.value.currentPassword,
      newPassword: passwordData.value.newPassword
    }, {
      withCredentials: true,
      timeout: 10000
    });
    
    const result = response.data;
    
    if (result.success) {
      snackbar.value.message = '비밀번호가 성공적으로 변경되었습니다.';
      snackbar.value.color = 'success';
      snackbar.value.show = true;
      closePasswordModal();
    } else {
      console.error('비밀번호 변경 실패:', result.message);
      snackbar.value.message = result.message || '비밀번호 변경에 실패했습니다.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
    }
  } catch (error) {
    console.error('비밀번호 변경 오류:', error);
    snackbar.value.message = '비밀번호 변경 중 오류가 발생했습니다.';
    snackbar.value.color = 'error';
    snackbar.value.show = true;
  } finally {
    passwordLoading.value = false;
  }
};

// 사용자 정보 수정
const updateUserInfo = async () => {
  loading.value = true;
  try {
    const response = await axios.put(`${API_BASE_URL}/auth/account`, userInfo.value, {
      withCredentials: true,
      timeout: 10000,
      headers: {
        'Content-Type': 'application/json'
      }
    });
    
    const result = response.data;
    if (result.success) {
      // Vuex 스토어의 사용자 정보도 업데이트 (저장소에도 저장)
      store.commit('updateUser', userInfo.value);
      snackbar.value.message = '사용자 정보가 성공적으로 수정되었습니다.';
      snackbar.value.color = 'success';
      snackbar.value.show = true;
    } else {
      console.error('사용자 정보 수정 실패:', result.message);
      snackbar.value.message = result.message || '사용자 정보 수정에 실패했습니다.';
      snackbar.value.color = 'error';
      snackbar.value.show = true;
    }
  } catch (error) {
    console.error('사용자 정보 수정 오류:', error);
    snackbar.value.message = '사용자 정보 수정 중 오류가 발생했습니다.';
    snackbar.value.color = 'error';
    snackbar.value.show = true;
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.user-info-page {
  width: 100%;
  min-height: calc(100vh - 50px);
  background-color: #f7f8fa;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 16px;
  overflow-y: auto;
}

.user-info-card {
  width: 100%;
  max-width: 900px;
  min-height: auto;
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(20, 33, 61, 0.08);
  border: 1px solid #e8eaf0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
}

.user-info-card .v-card-title {
  background-color: #ffffff;
  color: #333333;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 8px 8px 0 0;
  flex-shrink: 0;
  padding: 16px 20px 12px 20px !important;
}

.logo-filter {
  filter: none;
}

.v-card-text {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 16px 20px;
  gap: 12px;
}

.v-card-actions {
  flex-shrink: 0;
}

.signup-title-text {
  font-size: 1.5rem;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 4px;
}

.signup-submit-btn {
  height: 42px !important;
  font-size: 15px !important;
  font-weight: 600 !important;
  text-transform: none !important;
}

.login-back-btn {
  height: 42px !important;
  font-size: 15px !important;
  text-transform: none !important;
}

/* 섹션 스타일 */
.form-section {
  border: 1px solid #eef1f6;
  border-radius: 8px;
  padding: 12px 14px;
  background-color: #ffffff;
  box-shadow: 0 1px 2px rgba(0,0,0,0.02);
  margin-bottom: 12px;
  
  .section-title {
    color: #133e87;
    font-size: 0.95rem;
    font-weight: 700;
    padding-bottom: 8px;
    margin-bottom: 8px;
    border-bottom: 2px solid #e5e7eb;
  }
  
  .compact-field {
    margin-bottom: 0;
  }
}

/* 주소 입력 필드 */
.address-fields-wrapper {
  margin-top: 0;
}

.address-input-group {
  display: flex;
  gap: 6px;
  flex: 1;
  align-items: center;
  
  .compact-input {
    flex: 1;
    cursor: pointer;
  }
}

/* 주소 검색 로딩 오버레이 */
.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 10;
}

.loading-text {
  font-size: 0.9rem;
  color: #666;
  text-align: center;
}

.form-label {
  display: block;
  font-size: 0.8rem;
  font-weight: 500;
  color: #424242;
  margin-bottom: 6px;
}

/* compact-field 스타일 (PgmSignup과 동일) */
.compact-field {
  padding: 6px 0;
  border-bottom: 1px solid #e5e7eb;
  
  &:last-child {
    border-bottom: none;
  }
  
  &.required-field {
    .compact-input {
      border-color: #fcd34d;
      background-color: #fffbeb;
      
      &:focus {
        border-color: #f59e0b;
        box-shadow: 0 0 0 2px rgba(245, 158, 11, 0.1);
      }
    }
  }
  
  .compact-label {
    display: block;
    font-size: 13px;
    font-weight: 600;
    color: #4b5563;
    letter-spacing: 0.1px;
    margin-bottom: 4px;
    text-align: left;
    
    .required-mark {
      color: #ef4444;
      font-weight: 700;
    }
  }
  
  .field-hint {
    display: block;
    font-size: 11px;
    color: #f59e0b;
    margin-top: 4px;
    font-weight: 500;
  }
  
  .compact-input {
    width: 100%;
    height: 36px;
    padding: 0 12px;
    font-size: 14px;
    font-weight: 500;
    color: #1a1a1a;
    background-color: #ffffff;
    border: 1.5px solid #d1d5db;
    border-radius: 4px;
    transition: all 0.15s ease;
    box-sizing: border-box;
    
    &:focus {
      outline: none;
      border-color: #6366f1;
      box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
    }
    
    &:hover:not(:focus) {
      border-color: #9ca3af;
    }
    
    &[readonly] {
      background-color: #f9fafb;
      color: #1a1a1a;
      cursor: pointer;
      font-weight: 600;
      
      &:focus {
        border-color: #d1d5db;
        box-shadow: none;
      }
      
      &:hover {
        border-color: #9ca3af;
      }
    }
    
    &::placeholder {
      color: #9ca3af;
      font-weight: 400;
      font-size: 13px;
    }
  }
  
  .input-with-suffix {
    position: relative;
    width: 100%;
    
    .compact-input {
      padding-right: 40px;
      width: 100%;
    }
  }
  
  .address-input-group {
    width: 100%;
    display: flex;
    gap: 6px;
    align-items: center;
    
    .compact-input {
      flex: 1;
    }
  }
}

.password-toggle-btn {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: color 0.15s ease;
  z-index: 1;
  border-radius: 4px;
  
  &:hover {
    color: #374151;
    background-color: rgba(0, 0, 0, 0.02);
  }
  
  &:active {
    background-color: rgba(0, 0, 0, 0.05);
  }
}

.address-search-btn {
  padding: 0 14px;
  height: 36px;
  font-size: 13px;
  font-weight: 600;
  color: #ffffff;
  background: linear-gradient(135deg, #6366f1 0%, #4f46e5 100%);
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
  flex-shrink: 0;
  
  &:hover {
    background: linear-gradient(135deg, #4f46e5 0%, #4338ca 100%);
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
  }
  
  &:active {
    transform: translateY(0);
  }
}

/* 전화번호 입력 그룹 */
.phone-input-group {
  display: flex;
  align-items: center;
  gap: 4px;
  
  .phone-input {
    flex: 1;
    text-align: center;
    min-width: 0;
  }
  
  .phone-separator {
    color: #6b7280;
    font-weight: 500;
    flex-shrink: 0;
  }
}

/* v-row, v-col 간격 조정 */
:deep(.v-row) {
  margin: 0 -6px;
}

:deep(.v-col) {
  padding: 0 6px;
}

/* 파일 입력 컴팩트 스타일 */
.compact-file-input {
  :deep(.v-field) {
    min-height: 36px !important;
  }
  
  :deep(.v-field__input) {
    min-height: 36px !important;
    padding-top: 4px !important;
    padding-bottom: 4px !important;
    font-size: 14px !important;
  }
}

/* 비밀번호 변경 모달 스타일 */
.password-dialog {
  .compact-field {
    margin-bottom: 12px;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}

/* 폰트 적용 */
.user-info-page,
.password-dialog {
  font-family: 'Noto Sans KR', sans-serif !important;
}

.user-info-page * {
  font-family: 'Noto Sans KR', sans-serif !important;
}

</style>
